import React, { createContext, useReducer } from 'react'

export const SET_SALES_CODE_DATA = 'set_sales_code_data'
export const UPDATE_CHANGE_SALES_CODE_DATA = 'update_change_sales_code_data'
export const SET_SELECTED_SALES_CODE_DATA = 'set_selected_sales_code_data'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_SALES_CODE_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_CHANGE_SALES_CODE_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData }
    }
    case SET_SELECTED_SALES_CODE_DATA: {
      return { ...data, selectedObject: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedObject: {},
}

const SalesCodesStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <SalesCodesContext.Provider value={[state, dispatch]}>
      {children}
    </SalesCodesContext.Provider>
  )
}

export const SalesCodesContext = createContext(initialState)
export default SalesCodesStore
